<template>
    <div></div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'App',
  components: {
  },
  
  created: function () {
    this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/')
        })
  }
};
</script>